import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { NarakeetCreditsInfo, ServiceCreditsService } from '@app/services/service-credits.service';
import { extractApiErrorMessage } from '@app/utils/ai-error-prompt';

@Component({
  selector: 'app-admin-service-credits',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-service-credits.component.html',
})
export class AdminServiceCreditsComponent {
  narakeetLoading = false;
  narakeetError = '';
  narakeet: NarakeetCreditsInfo | null = null;

  constructor(
    private creditsSvc: ServiceCreditsService,
    private toastr: ToastrService,
  ) {}

  checkNarakeet(): void {
    this.narakeetLoading = true;
    this.narakeetError = '';
    this.creditsSvc.getNarakeetCredits().subscribe({
      next: (data) => {
        this.narakeetLoading = false;
        this.narakeet = data || null;
        if (data?.creditSeconds == null && data?.message) {
          this.narakeetError = String(data.message);
          this.toastr.error(this.narakeetError);
          return;
        }
        this.toastr.success('Narakeet credits updated');
      },
      error: (err) => {
        this.narakeetLoading = false;
        this.narakeet = null;
        this.narakeetError = extractApiErrorMessage(err, 'Failed to fetch Narakeet credits');
        this.toastr.error(this.narakeetError);
      },
    });
  }

  formatSeconds(sec: number | null | undefined): string {
    if (sec == null || !Number.isFinite(Number(sec))) return '—';
    const s = Math.max(0, Math.floor(Number(sec)));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    if (h > 0) return `${h}h ${m}m ${r}s (${s} seconds)`;
    if (m > 0) return `${m}m ${r}s (${s} seconds)`;
    return `${s} seconds`;
  }
}
